module.exports = __webpack_public_path__ + "img/support.1159bbf0.webp";